import React, { CSSProperties } from "react";
import TextCellInfo from "../gridCells/TextCellInfo";

export default function DataTable(props: {
  itemKeys: string[];
  sourceMap: { [key: string]: Set<string> };
  sources: Set<string>;
}) {
  // TODO: highlight rule items without a source
  // TODO: allow the admin to click in a cell and update the rule item to have that source
  // TODO: have a show more that'll show the things items could rely on (limit it?)
  // TODO: organize sources by module (new data structure)
  const items = props.itemKeys.map((key) => {
    return (
      <TextCellInfo
        key={`item-${key}`}
        dataTest={`item-column-${key}`}
        text={key}
        classes="upright"
      />
    );
  });
  const rows: JSX.Element[] = [];
  props.sources.forEach((source) => {
    rows.push(
      <TextCellInfo
        key={`cell-row-${source}`}
        dataTest={`item-row-${source}`}
        text={source}
      />
    );
    props.itemKeys.forEach((key) => {
      if (key in props.sourceMap && props.sourceMap[key].has(source)) {
        rows.push(
          <TextCellInfo
            key={`cell-${source}-${key}`}
            dataTest={`cell-${source}-${key}-checked`}
            text="✔"
          />
        );
      } else {
        rows.push(
          <TextCellInfo
            key={`cell-${source}-${key}`}
            dataTest={`cell-${source}-${key}-unchecked`}
            text=""
          />
        );
      }
    });
  });
  const styles: CSSProperties = {
    gridTemplateColumns: `auto repeat(${items.length}, 1fr)`,
  };
  return (
    <div className="grid-container grid-data-table" style={styles}>
      <TextCellInfo text="" dataTest="empty" />
      {items}
      {rows}
    </div>
  );
}
